// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/newstyle.css
// module id = 1664
// module chunks = 4